import { render, staticRenderFns } from "./TablePageDeleted.vue?vue&type=template&id=1ccef6e6"
import script from "./TablePageDeleted.vue?vue&type=script&lang=js"
export * from "./TablePageDeleted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports